import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import SEOMeta from "components/SEOMeta";
import DealerCard from "../components/DealerCard";
import { brandConfig, listeRevendeurs } from "config/brandConfig";

export default function Dealers() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([
      { label: "Accueil", href: "/" },
      { label: "Revendeurs certifiés" },
    ]);
  }, [setItems]);

  return (
    <>
      <SEOMeta
        title="Liste des revendeurs"
        description={`Découvrez la liste des revendeurs ${brandConfig.brandName} pour toute demande commerciale ou information produit.`}
      />
      <h1>Revendeurs {brandConfig.brandName} – Revendeurs certifiés</h1>
      <p>
        Retrouvez ici les points de vente et partenaires proposant des produits
        TresorSafe.
      </p>
      <div className="grid" style={{ marginTop: 12 }}>
        {listeRevendeurs.map(
          ({ name, location, website, partenaire, description, reviews }) => (
            <DealerCard
              key={name}
              name={name}
              location={location}
              website={website}
              partenaire={partenaire}
              description={description}
              reviews={reviews}
            />
          ),
        )}
      </div>
      <p className="color-product-desc" style={{ marginTop: 12 }}>
        Vous souhaitez devenir revendeur ? <a href="/contact">Contactez-nous</a>
        .
      </p>
    </>
  );
}
